/**
 * Approvals inbox helpers — plan/14, plan/27 phone queue.
 */

export type ApprovalsTab = "destructive" | "operational" | "all";

/** Prefer the tab that has work waiting. */
export function defaultApprovalsTab(counts: {
  destructive: number;
  operational: number;
}): ApprovalsTab {
  if (counts.destructive > 0) return "destructive";
  if (counts.operational > 0) return "operational";
  return "all";
}

/** Flatten payload object for review lists. */
export function payloadRows(
  payload: Record<string, unknown> | null | undefined,
): Array<{ key: string; value: string }> {
  if (!payload || typeof payload !== "object") return [];
  return Object.entries(payload).map(([key, value]) => ({
    key,
    value:
      typeof value === "string" || typeof value === "number"
        ? String(value)
        : JSON.stringify(value),
  }));
}

/** Short label for list/detail chrome. */
export function humanizeApprovalSource(
  source: "override" | "change",
): string {
  return source === "override" ? "Override" : "Change";
}

/** Permission key → short phone-friendly title. */
export function humanizePermissionKey(key: string): string {
  const map: Record<string, string> = {
    "pos.void": "Void sale",
    "pos.discount_over_cap": "Discount over cap",
    "pos.oversell": "Oversell",
    "pos.return": "Return",
  };
  if (map[key]) return map[key];
  const leaf = key.includes(".") ? key.slice(key.lastIndexOf(".") + 1) : key;
  return leaf.replace(/_/g, " ");
}
